module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('collapse-transition', [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    class: _vm.classes
  }, [_c('li', [_c('span', {
    class: _vm.arrowClasses,
    on: {
      "click": _vm.handleExpand
    }
  }, [_c('Icon', {
    attrs: {
      "type": "arrow-right-b"
    }
  })], 1), _vm._v(" "), (_vm.showCheckbox) ? _c('Checkbox', {
    attrs: {
      "value": _vm.data.checked,
      "indeterminate": _vm.indeterminate,
      "disabled": _vm.data.disabled || _vm.data.disableCheckbox
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleCheck($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    class: _vm.titleClasses,
    domProps: {
      "innerHTML": _vm._s(_vm.data.title)
    },
    on: {
      "click": _vm.handleSelect
    }
  }), _vm._v(" "), _vm._l((_vm.data.children), function(item) {
    return _c('Tree-node', {
      key: item,
      attrs: {
        "data": item,
        "visible": _vm.data.expand,
        "multiple": _vm.multiple,
        "show-checkbox": _vm.showCheckbox
      }
    })
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a210ecf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/tree/node.vue
// module id = 609
// module chunks = 1